<zbp-button-component
  id="lessonMaterialsButton"
  [ngbPopover]="popoverControl?.popoverContent"
  popoverClass="viewer-control-popover"
  [popperOptions]="popperOptions"
  autoClose="outside"
  (shown)="showPopover()"
  [placement]="isDesktop ? 'right' : 'top'"
  container="body"
  [openDelay]="0"
  [closeDelay]="0"
  theme="viewerControl"
  label="Lesson Materials"
  ariaLabel="lesson materials"
  iconPosition="top"
  [iconName]="zbpIconNames.files"
  #popover="ngbPopover"
/>
<zbp-viewer-control-popover
  #popoverControl="ControlPopoverComponent"
  title="Lesson Materials"
  (shouldClosePopover)="popover.close()"
  [hidden]="true">

  @if (hasLoadedLessonSteps) {
    <div class="scrollContainer">
      <ul class="lessStepList">
        @for (step of lessonSteps; track $index) {
          <li class="lessonStep">
            <h2 class="lessonStepHeader">{{ step.header }}</h2>
            <ul class="assetLinkList">
              @for (link of step.assetLinks; track $index) {
                <li>
                  <a class="assetLink"
                     [class.activeAssetLink]="link.builtIsActiveAssetLink"
                     href="#"
                     (keydown.space)="onAssetLinkClick($event, link)"
                     (click)="onAssetLinkClick($event, link)">
                    {{ link.displayText }}
                    @if (!link.builtIsLocalViewerResult) {
                      <zbp-icon
                        [iconName]="zbpIconNames.openInNewIcon"
                        iconSize="font-size"
                      />
                      <span class="sr-only">
                        &nbsp;(opens in a new tab)
                      </span>
                    }
                    @if (link.builtIsActiveAssetLink) {
                      <span class="sr-only">
                        &nbsp;(currently selected)
                      </span>
                    }
                  </a>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
  } @else {
    <zbp-preloader/>
  }
</zbp-viewer-control-popover>
